import {createStore, applyMiddleware, compose} from 'redux'
import logger from 'redux-logger'
import {routerMiddleware} from 'react-router-redux'
import reducer from './reducer'
import history from '../history'
import thunk from 'redux-thunk'
import randomId from './middlewares/randomId'
import localData from './middlewares/localData'
import questionsStatistic from './middlewares/questionsStatistic'
import { loadingBarMiddleware, showLoading } from 'react-redux-loading-bar'
import {LOADER_BAR_MODAL_SCOPE, LOADER_BAR_Q_LOADER_MODAL_SCOPE} from '../settings/constants'

const composeEnhancers =
  typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?   
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
    }) : compose;

const enchancer = composeEnhancers(
    applyMiddleware(
        questionsStatistic,
        thunk,
        randomId,
        localData,
        routerMiddleware(history),
        loadingBarMiddleware({
            scope : LOADER_BAR_Q_LOADER_MODAL_SCOPE,
        }),
        loadingBarMiddleware({
            scope : LOADER_BAR_MODAL_SCOPE,
        })/*,
        logger*/
    )
);

const store = createStore(reducer, enchancer)


// TODO dev only
window.store = store

export default store

window.___showLoading = showLoading


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/redux/index.js